'use strict';

var angular = require('angular');
var dependecies = ['AVRO.Common.Moment', 'AVRO.Common.DataRetriever'];
module.exports = angular.module('AVRO.Grid.Drawer.MappedBookings', dependecies).directive('rmMappedBookings', require('./directives/MappedBookingsDirective')).controller('MappedBookingsController', require('./controllers/MappedBookingsController')).factory('MappedBookingsDataRetrieverService', require('./services/MappedBookingsDataRetrieverService'));